import React from 'react';
import './footer.css'

const Footer = () => {
  return (
    <footer className="global-footer">
      <p>Copyright ©2026 Cnyda Dynamics Inc.</p>
    </footer>
  );
};

export default Footer;  